const bigCardSlider = () => {
	let slideIndex = 1;
	const sliderItems = document.querySelectorAll('.wp-block-pushengage-theme-single-big-card-slider-item');
	const sliderLeftArrowBtn = document.querySelectorAll('.pushengage-single-big-card-slider-left-arrow');
	const sliderRightArrowBtn = document.querySelectorAll('.pushengage-single-big-card-slider-right-arrow');

	// function to performing the slider action.
	const sliderActionPerform = (value) => {
		slideIndex += value;

		if (slideIndex > sliderItems.length) {
			slideIndex = 1
		}

		if (1 > slideIndex) {
			slideIndex = sliderItems.length
		}

		sliderItems.forEach((item) => {
			item.classList.add('hidden');
		});

		// show the current slide
		sliderItems[ slideIndex - 1 ].classList.remove('hidden');
	}

	if (!sliderItems.length) {
		return;
	}

	if (!sliderLeftArrowBtn.length) {
		return;
	}

	if (!sliderLeftArrowBtn.length) {
		return;
	}

	// To show the initial view
	sliderActionPerform(slideIndex);

	sliderLeftArrowBtn[ 0 ].addEventListener('click', () => {
		sliderActionPerform(1);
	});

	sliderRightArrowBtn[ 0 ].addEventListener('click', () => {
		sliderActionPerform(-1);
	});
};

export default bigCardSlider;